<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> {{name}}
            <span class="tt">{{title}}</span>
        </header>
        <div class="timeBox">
            <div class="tt">
                <img src="../../assets/jxwx/line.png" alt="">本月明细
            </div>
            <!-- <div class="time">
                选择时间<img src="../../assets/jxwx/arr_04.png" alt="">
            </div> -->
        </div>
        <div class="chargeList f-bcf">
            <div class="tt">本月累计</div>
            <div class="totalNum ">{{data.monthTotal | moneyP}}</div>
            <div class="box">
                <div class="progressBox" v-for="item in data.JXRecordList" :key="item.id">
                    <span class="time">{{item.feedate}}</span>
                    <div class="u-progress">
                        <div class="progress_bar progress_bar_02" :style="{width: item.percent}">
                        </div>
                    </div>
                    <span class="num">{{item.total || item.totalFee | moneyP}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            name: this.$route.query.name,
            title: this.$route.query.title,
            data: this.$route.query.data,
            active: 0,
            widthPer: "100%"
        };
    },
    mounted() {},
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        }
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 0 0 3.3vw;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.timeBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10.6vw;
    padding: 0 4vw;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    background-color: #fff;
    font-size: 16px;
    img {
        width: 1vw;
        margin-right: 3.2vw;
    }
    .time {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #a6a6a6;
        img {
            width: 2.4vw;
            margin-left: 2vw;
            margin-right: 0;
        }
    }
}
.chargeList {
    padding-top: 4.6vw;
    .tt {
        margin: 0 0 1.6vw 0;
        font-size: 13px;
        color: #a6a6a6;
        text-align: center;
    }
    .totalNum {
        font-size: 28px;
        color: #e5323b;
        text-align: center;
    }
    .box {
        padding: 6vw 0;
        .progressBox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 4vw;
            border-bottom: 1px solid #dedede;
            span {
                display: inline-block;
                width: 25vw;
                font-size: 13px;
                box-sizing: border-box;
            }
            .time {
                color: #a6a6a6;
            }
            .num {
                padding-left: 4vw;
            }
        }
        .progressBox:first-child {
            border-top: 1px solid #dedede;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/details.vue